import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfigService } from 'src/app/core/service/config.service';

@Component({
  selector: 'app-not-enough-fund',
  templateUrl: './not-enough-fund.component.html',
  styleUrls: ['./not-enough-fund.component.css']
})
export class NotEnoughFundComponent implements OnInit {

  constructor(
    public _config: ConfigService,
    public dialogRef: MatDialogRef<NotEnoughFundComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }
  confirm() {
    this.dialogRef.close('success');
    this._config._router.navigate(['/myProfile']);
  }
}
